module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bulb2-d9d62f0f9929043f1f6d83ee54c62079.svg";